import type { SVGProps } from "react"
import { colorIconComponents } from "./colorIconRenderer"
import type { ColorIconName } from "./types"

export interface ColorIconProps extends SVGProps<SVGSVGElement> {
  name: ColorIconName
}

/**
 * Renders a color icon component based on the provided name.
 * Color icons are full-color, non-themeable icons typically used for brands/platforms.
 */
export function ColorIcon({ name, className, ...props }: ColorIconProps) {
  const IconComponent = colorIconComponents[name]

  if (!IconComponent) {
    console.error(`Color icon "${name}" not found`)
    return null
  }

  // Pass className and other props to the color icon component
  // Note: Color icon components already have their own w-[1em] h-[1em] defaults
  return <IconComponent className={className} {...props} />
}
